// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SM5cA","textarea":"styles_textarea__2e43z"};